import profileRoutes from "@/router/profileRoutes";
import documentRoutes from "@/router/spa/documents/index";
import projectsRoutes from "@/router/spa/projects/index";
import contractsRoutes from "@/router/spa/contracts/index";

export default [
    {
        path: "home",
        name: "home",
        meta: {
            title: "",
            subtitle: "home.page.title",
        },
        redirect: { name: "projects_index" },
        component: () =>
            import(/* webpackChunkName: "Home" */ "../../views/Home.vue"),
    },
    ...projectsRoutes,
    ...contractsRoutes,
    documentRoutes,
    {
        path: "upgrade",
        name: "upgrade",
        meta: {
            title: false,
            // sideCollapse: true
        },
        component: () =>
            import(/* webpackChunkName: "Upgrade" */ "../../views/Upgrade.vue"),
    },
    {
        path: "settings",
        meta: {
            title: "Personal settings",
        },
        component: () =>
            import(
                /* webpackChunkName: "SettingsWrapper" */ "../../views/Wrapper.vue"
            ),
        children: [
            {
                path: "",
                name: "settings",
                meta: {
                    title: "Personal settings",
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Settings" */ "../../views/Settings.vue"
                    ),
            },
            {
                path: "billing",
                name: "billing",
                meta: {
                    title: false,
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Billing" */ "../../views/Billing.vue"
                    ),
            },
        ],
    },
    ...profileRoutes,
];
